module.exports = "/img/car-gallery-left.d940abc5.png";